import type { ComponentProps } from "react"
import { DayPicker } from "react-day-picker"
import "react-day-picker/style.css"

import { cn } from "@/lib/utils"

export type CalendarProps = ComponentProps<typeof DayPicker>

// Thin wrapper over react-day-picker using its bundled styles.
export function Calendar({ className, ...props }: CalendarProps) {
  return (
    <DayPicker showOutsideDays className={cn("p-2", className)} {...props} />
  )
}
